<template>
    <Error404 v-if="error?.statusCode === 404" :error="error" />
    <Error500 v-else-if="error?.statusCode === 500" :error="error" />
    <Error404 v-else :error="error" />
</template>

<script setup lang="ts">
    const error = useError(); // 获取错误对象

    // 确保错误状态码正确设置
    if (error.value) {
        const err = error.value as any
        const timestamp = new Date().toISOString()
        const stack = err.stack || err.cause?.stack || 'N/A'
        console.log('Error page - timestamp:', timestamp)
        console.log('Error page - statusCode:', err.statusCode);
        console.log('Error page - statusMessage:', err.statusMessage);
        console.log('Error page - stack:', stack)

        // 设置响应状态码
        if (import.meta.server) {
            setResponseStatus(err.statusCode || 500)
        }
    }
</script>

